import { render, staticRenderFns } from "./index.vue?vue&type=template&id=48de21aa"
import script from "./applicationCriteria.js?vue&type=script&lang=js&external"
export * from "./applicationCriteria.js?vue&type=script&lang=js&external"
import style0 from "./applicationCriteria.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports